export const FileIcon = ({color}: {color?:string}) => {
    const defaultColor = '#0089d6'
    return (
        <p style={{fontFamily: "FontAwesome, sans-serif", fontWeight: 400, marginLeft:"inherit",marginRight:"5px", color: color ?? defaultColor}}></p>
    );
}